import { Cloudfront, CloudfrontActions, fetchCloudfrontActionTypes } from './cloudfrontActions'
import { FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from '../../../..'
import { isEqualJson } from '../../../../utils/equal/equal'

export interface CloudfrontState {
    isFetching: boolean
    data?: Cloudfront
    error?: FetchErrorInfo
}

export const initialCloudfrontState: CloudfrontState = {
    isFetching: false
}

export const cloudfrontReducer = (state: CloudfrontState = initialCloudfrontState, action: CloudfrontActions): CloudfrontState => {
    switch (action.type) {
        case fetchCloudfrontActionTypes.start: {
            return {
                data: state.data,
                isFetching: true
            }
        }
        case fetchCloudfrontActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Cloudfront>
            const newState: CloudfrontState = {
                isFetching: false,
            }
            if(!isEqualJson(successAction.result, state.data)){
                newState.data = successAction.result
            }
            return {
                ...newState
            }
        }
        case fetchCloudfrontActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                isFetching: false,
                error: errorAction.error
            }
        }
        default:
            return state
    }
}